import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setAuthHeader } from './apiHelpers';
import { liveAppUrl, demoAppUrl, localAppUrl } from '../../config';

const currentURL = window.location.href;
const appURL = currentURL.includes('localhost') ? localAppUrl : currentURL.includes('glidix') ? demoAppUrl : liveAppUrl;

export const navigationApi = createApi({
  reducerPath: 'navigationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: appURL,
    prepareHeaders: (headers) => {
      setAuthHeader(headers);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchNavigations: builder.query({
      query: (params) => {
        if (params?.search) {
          return `/navigation/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}&search=${params.search}`;
        } else if (params?.page) {
          return `/navigation/list?page=${params?.page ? params?.page : 1}&perPage=${params?.perPage ? params?.perPage : 10}`;
        } else {
          return '/navigation/list';
        }
      }
    }),
    fetchNavigationDetail: builder.query({
      query: (id) => `/navigation/detail/${id}`,
    }),
    createNavigation: builder.mutation({
      query: (credentials) => ({
        url: '/navigation/store',
        method: 'POST',
        body: credentials,
      }),
    }),
    updateNavigation: builder.mutation({
      query: (credentials) => ({
        url: '/navigation/update',
        method: 'PUT',
        body: credentials,
      }),
    }),
    deleteNavigation: builder.mutation({
      query: (id) => ({
        url: `/navigation/delete/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useFetchNavigationsQuery,
  useFetchNavigationDetailQuery,
  useCreateNavigationMutation,
  useUpdateNavigationMutation,
  useDeleteNavigationMutation
} = navigationApi;
